/**
 * Command names the Remote sends to the TV.
 *
 * The frozen @spaces/contracts `COMMANDS` (seeded verbatim from spot-client) is
 * the canonical wire set and is re-exported unchanged. ONE addition is needed for
 * the room-initiated recording feature: a `setRecording` command. The frozen
 * COMMANDS has `grantRecordingConsent` but NO start/stop-recording command — the
 * Phase-1 room-recording work (spot branch `phase1-room-recording`) needs this
 * added to `@spaces/contracts` COMMANDS as an append-only growth.
 *
 * Because the contracts are FROZEN / read-only in this dispatch, the new name is
 * declared HERE and reported back as a needed contract addition. The room-do
 * relays command frames opaquely (it does not validate the command string), so
 * `setRecording` flows TV<-Remote over the live control plane unchanged today; the
 * only follow-up is to lift this constant into the frozen COMMANDS + add a
 * `CommandPayloads['setRecording']` entry.
 */

import { COMMANDS, type CommandName } from '@spaces/contracts';

export { COMMANDS };

/**
 * PENDING CONTRACT ADDITION — propose `COMMANDS.SET_RECORDING = 'setRecording'`.
 * Toggles room (file) recording on the TV's meeting. Moderator-gated on the UI.
 */
export const SET_RECORDING = 'setRecording';

/** Payload for {@link SET_RECORDING}. */
export interface SetRecordingPayload {
    /** Start (true) or stop (false) recording. */
    on: boolean;
}

/** Every command the client may send: the frozen set plus the pending recording one. */
export type ClientCommandName = CommandName | typeof SET_RECORDING;
